import React, { useState } from 'react';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter signup:', email);
  };
  return <section className="bg-mocha py-16 md:py-24 px-6" data-id="element-136">
      <div className="max-w-2xl mx-auto text-center" data-id="element-137">
        <h2 className="font-serif font-light text-3xl md:text-4xl text-cream mb-4" data-id="element-138">
          Join the Pure Pulse community.
        </h2>
        <p className="text-cream/90 text-lg mb-8" data-id="element-139">
          Early access to drops, restocks, and 10% off your first order.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto" data-id="element-140">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email" className="flex-1 px-6 py-4 rounded-full bg-cream text-espresso placeholder:text-espresso/50 focus:outline-none focus:ring-2 focus:ring-rust min-h-[48px]" required data-id="element-141" />
          <button type="submit" className="bg-espresso text-cream px-8 py-4 rounded-full uppercase tracking-widest text-sm hover:bg-rust transition-colors min-h-[48px] whitespace-nowrap" data-id="element-142">
            SUBSCRIBE
          </button>
        </form>

        <p className="text-cream/60 text-xs mt-4" data-id="element-143">
          We respect your privacy. Unsubscribe at any time.
        </p>
      </div>
    </section>;
}